import React, { useEffect, useRef, useCallback } from 'react';

// Component
function ClickOutside(_ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      onClickOutside = _ref.onClickOutside;
  var elRef = useRef(null);
  var handleClick = useCallback(function (e) {
    if (elRef.current && !elRef.current.contains(e.target)) onClickOutside();
  }, [onClickOutside, elRef]);
  useEffect(function () {
    // Add listener in next frame to prevent insta-click on appearing
    window.requestAnimationFrame(function () {
      return window.addEventListener('click', handleClick);
    });
    return function () {
      return window.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
  return /*#__PURE__*/React.createElement("div", {
    ref: elRef,
    className: className,
    style: style
  }, children);
} // Default Props


ClickOutside.defaultProps = {
  style: undefined,
  className: undefined
};
export default ClickOutside;